import { PageHeader } from '../ds/index'
import ClientDocuments from '../components/ClientDocuments'

/** What every client sees under Resources in their portal. Per-client documents live on each client's page. */
export default function Resources({ embedded = false }: { embedded?: boolean } = {}) {
  const note = "Price sheets, how leads work, contracts and onboarding guides. Everything here shows in every client's portal under Resources. To share something with one client only, add it on that client's page."
  return (
    <>
      {embedded ? <p className="muted" style={{ marginTop: 0 }}>{note}</p> : <PageHeader title="Client resources" subtitle={note} />}
      <ClientDocuments clientId={null} />
    </>
  )
}
